function data() {
    function getThemeFromLocalStorage() {
        if (window.localStorage.getItem('dark')) {
            return JSON.parse(window.localStorage.getItem('dark'));
        }
        return (
            !!window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches
        );
    }

    function setThemeToLocalStorage(value) {
        window.localStorage.setItem('dark', value);
    }

    function getSidebarCollapsed() {
        if (window.localStorage.getItem('sidebarCollapsed')) {
            return JSON.parse(window.localStorage.getItem('sidebarCollapsed'));
        }
        return false;
    }

    return {
        dark: getThemeFromLocalStorage(),
        toggleTheme() {
            this.dark = !this.dark;
            setThemeToLocalStorage(this.dark);
            document.documentElement.classList.toggle('dark', this.dark);
        },
        sidebarCollapsed: getSidebarCollapsed(),
        toggleSidebar() {
            this.sidebarCollapsed = !this.sidebarCollapsed;
            window.localStorage.setItem('sidebarCollapsed', this.sidebarCollapsed);
        },
        isSideMenuOpen: false,
        toggleSideMenu() {
            this.isSideMenuOpen = !this.isSideMenuOpen;
        },
        closeSideMenu() {
            this.isSideMenuOpen = false;
        },
        isPagesMenuOpen: false,
        togglePagesMenu() {
            this.isPagesMenuOpen = !this.isPagesMenuOpen;
        },
        isModalOpen: false,
        trapCleanup: null,
        openModal() {
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
            if (this.trapCleanup) this.trapCleanup();
        },
        isUserMenuOpen: false,
        toggleProfileMenu() {
            this.isUserMenuOpen = !this.isUserMenuOpen;
        },
        closeProfileMenu() {
            this.isUserMenuOpen = false;
        },
        init() {
            document.documentElement.classList.toggle('dark', this.dark);
        },
    };
}

window.data = data;
